var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.FF_Devices
    ? _c(
        "div",
        {
          staticClass:
            "subpage-dashboards gmp-devices-page gmp-devices-page__temp-assets"
        },
        [_vm._m(0), _vm._v(" "), _c("div")]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h2", { staticClass: "my-account__title gds-space-stack-default" }, [
        _vm._v("\n      Temp Assets\n    ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }